import React, { ChangeEvent } from 'react'
import { QuickSortHome } from './QuickSortHome';

export function QuickSortHomeWrapper () {

  const [Milliseconds, setMilliseconds] = React.useState(300);
  const [Play, setPlay] = React.useState(false);
  const [Rewind, setRewind] = React.useState(false);

  const handleMillisecondsChanged = (event : ChangeEvent<HTMLInputElement>) => {
    if (event !== null && event.target !== null)
      setMilliseconds(Number((event.target as HTMLInputElement).value));
  }

  const togglePlay = () => {
    if (Rewind)
      toggleRewind();
    setPlay(!Play);
  }

  const toggleRewind = () => {
    if (Play)
      togglePlay();
    setRewind(!Rewind);
  }

  return (
    <div>
      <button onClick={toggleRewind}>{Rewind ? 'Stop' : 'Rewind'}</button>
      <button onClick={togglePlay}>{Play ? 'Stop' : 'Play'}</button>
      <input type='number' min={100} max={1000} step={100} value={Milliseconds}
        onChange={handleMillisecondsChanged} />
      <QuickSortHome milliseconds={Milliseconds} play={Play} rewind={Rewind}/>
    </div>

  )
}
